import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import '../Auth.css';
import logo from '../../../assets/images/seedxpert-light.png';
import { useTranslation } from 'react-i18next';

const ResetPassword = () => {
  const { t } = useTranslation();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  
  const { token } = useParams();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (password !== confirmPassword) {
      setError(t('resetPassword.mismatchError'));
      return;
    }

    if (password.length < 6) {
      setError(t('resetPassword.lengthError'));
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      await axios.post(`/api/auth/reset-password/${token}`, {
        password,
        confirmPassword
      });

      setMessage(t('resetPassword.successMessage'));
      setTimeout(() => {
        navigate('/');
      }, 3000);
    } catch (err) {
      setError(err.response?.data?.msg || 'Hata oluştu');
    }
    setIsLoading(false);
  };

  return (
    <div className="auth-container">
      <div className="bg-animation">
        <div className="floating-shape shape-1"></div>
        <div className="floating-shape shape-2"></div>
        <div className="floating-shape shape-3"></div>
      </div>

      {/* DÜZELTME: register-box sınıfı ile stilleri geri getirdik */}
      <div className="register-box" style={{ maxWidth: '450px', margin: '0 auto' }}>
        <div className="logo-section">
          <img src={logo} alt="SeedXpert Logo" className="auth-logo" />
        </div>

        <div className="auth-header">
          <h2>{t('resetPassword.title')}</h2>
          <p className="auth-subtitle">{t('resetPassword.subtitle')}</p>
        </div>

        {message && <div className="success-message">{message}</div>}
        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{t('resetPassword.newPassword')}</label>
            <div className="password-input-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
              </button>
            </div>
          </div>

          <div className="form-group">
            <label>{t('resetPassword.confirmPassword')}</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          <br/>

          <button type="submit" className="auth-btn primary-btn" disabled={isLoading}>
            {isLoading ? '...' : t('resetPassword.submitButton')}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;